import { WhatsNewEntry } from "../../../core/models/entities/WhatsNewEntry";
import { WhatsNewEntryDto } from "../responses/WhatsNewDto";

export function mapToWhatsNewEntry(dto: WhatsNewEntryDto): WhatsNewEntry {
  return {
    id: dto.id,
    date: dto.date,
    icon: dto.icon,
    title: dto.title,
    body: dto.body,
    // Omitted audience means the entry is for everyone.
    audience: dto.audience ?? "all",
  };
}
